module.exports = __webpack_public_path__ + "static/visual_3_4_eg-b5a6684fef58e569135d6a402b3dd493.png";